import { DashboardConfig } from '../services/api';

let googleMapsPromise = null;

export const hasGoogleMapsKey = () => Boolean(String(DashboardConfig.googleMapsApiKey || '').trim());

export const loadGoogleMaps = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google Maps krever en nettleser.'));
  }
  if (window.google?.maps?.places) {
    return Promise.resolve(window.google);
  }
  const apiKey = String(DashboardConfig.googleMapsApiKey || '').trim();
  if (!apiKey) {
    return Promise.reject(new Error('Google Maps API-nøkkel mangler.'));
  }
  if (googleMapsPromise) return googleMapsPromise;

  googleMapsPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-kichat-google-maps="true"]');
    if (existing) {
      existing.addEventListener('load', () => resolve(window.google), { once: true });
      existing.addEventListener('error', () => reject(new Error('Kunne ikke laste Google Maps.')), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places&language=nb&region=NO`;
    script.async = true;
    script.defer = true;
    script.dataset.kichatGoogleMaps = 'true';
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error('Kunne ikke laste Google Maps.'));
    document.head.appendChild(script);
  });

  return googleMapsPromise;
};
